define.alias("shared/models/tiktok-post", "settings/models/tiktok-post");